import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { PartnerAbstractService } from '~/services/api/web/partner/partnerAbstractService';
import { HttpClientWrapper } from '~/services/api/httpClientWrapper';
import { BaseWebService } from '~/services/api/web/base/baseWebService';
import { ResponseModel } from '~/models/responseModel';
import { PartnerModel } from '~/models/partnerModel';
import { Observable } from 'rxjs';
import { map as _map } from 'lodash';
import { EpiModel } from '~/models/epiModel';
import { EditActAsGrowerModel } from '~/models/editActAsGrowerModel';

@Injectable()
export class PartnerService extends BaseWebService implements PartnerAbstractService {

    public static readonly PATH:string = '/partners';

    constructor(http: HttpClientWrapper) {
        super(http);
    }

    public getBrokersByEntityId(entityId:number) : Observable<ResponseModel> {
        let url:string = PartnerService.URL + PartnerService.PATH + '/entities/' + entityId.toString() + '/brokers';
        let options:{} = {};

        return this.http.get(url, options, (response:HttpResponse<any>) => {
            return _map(response['data'], (partner) => new PartnerModel(partner));
        });
    }

    public getBrokersByBrandId(brandId:number) : Observable<ResponseModel> {
        let url:string = PartnerService.URL + PartnerService.PATH + '/brands/' + brandId.toString() + '/brokers';
        let options:{} = {};

        return this.http.get(url, options, (response:HttpResponse<any>) => {
            return _map(response['data'], (partner) => new PartnerModel(partner));
        });
    }

    public getActAsGrower(brokerId:number) : Observable<ResponseModel> {
        let url:string = PartnerService.URL + PartnerService.PATH + '/actas/growers/' + brokerId.toString() ;
        let options:{} = {};

        return this.http.get(url, options, (response:HttpResponse<any>) => {
            return _map(response['data'], (partner) => new PartnerModel(partner));
        });
    }

    public getActAsBroker(growerId:number) : Observable<ResponseModel> {
        let url:string = PartnerService.URL + PartnerService.PATH + '/actas/brokers/' + growerId.toString() ;
        let options:{} = {};

        return this.http.get(url, options, (response:HttpResponse<any>) => {
            return _map(response['data'], (partner) => new PartnerModel(partner));
        });
    }

    public saveActAsGrower(partner:EditActAsGrowerModel) : Observable<ResponseModel> {
        let url:string = PartnerService.URL + PartnerService.PATH + '/actas/grower';
        let body = partner;
        let options:{} = {};

        return this.http.post(url, body, options);
    }

    /**
     * Adds a partnerStatus for each epiPartnerObject
     * @param {number} entityId
     * @param {[]} entities
     * @returns {Observable<>}
     */
    public addPartnerService(entityId:number, partners:EpiModel[]) : Observable<ResponseModel> {
        let url:string = PartnerService.URL + PartnerService.PATH + '/entities/addpartnerstatus';
        let body = {
            entityId: entityId,
            entities: partners
        };
        let options:{} = {};

        return this.http.post(url, body, options, (response:HttpResponse<any>) => {
            let entityId: number;
            let entities: EpiModel[] = [];
            
            if (response['data']){
                if (response['data']['entityId']){
                    entityId = response['data']['entityId'];
                }
                if (response['data']['entities']){
                    entities = _map(response['data']['entities'], (epi) => new EpiModel(epi))
                }
            }

            return {
                entityId: entityId,
                entities: entities
            };
        });
    }
}
